import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminRoute = ({ children }) => {
  const { user, hasToken } = useSelector((state) => state.user);

  if (!user && hasToken) {
    return <></>;
  }

  return user &&
    (user.roles.includes("admin") || user.roles.includes("superadmin")) ? (
    children
  ) : (
    <Navigate to='/' replace />
  );
};
export default AdminRoute;
